import { useRef, useState } from 'react'
import { useClickAway } from 'react-use'

import { Chevron } from '../../select/chevron'

import styles from './index.module.css'
import { Option } from './option'

interface Props {
  pageSize: number
  onPageSizeChange: (pageSize: number) => void
}

const options: number[] = [ 5, 10, 25, 50 ]

export function PageSizeSelector ({ pageSize: count, onPageSizeChange }: Props): JSX.Element {
  let [ open, setOpen ] = useState<boolean>(false)
  let clickAwayRef = useRef<HTMLButtonElement>(null)

  useClickAway(clickAwayRef, () => {
    setOpen(false)
  })

  function handlePageSizeChange (value: number): void {
    setOpen(false)
    onPageSizeChange(value)
  }

  return (
    <button
      ref={clickAwayRef}
      className={styles.wrapper}
      onClick={() => {
        setOpen(prevOpen => !prevOpen)
      }}
    >
      <span>{count}</span>
      <div style={{ width: '10px', height: '18px' }}>
        <Chevron />
      </div>

      {open &&
        <div className={styles.dropdown}>
          {options.map((option) => (
            <Option
              key={option}
              value={option}
              onChange={handlePageSizeChange}
            />
          ))}
        </div>
      }
    </button>
  )
}
